<template>
	<div class="home">
		<Encabezado></Encabezado>
        <div id="content" class="snap-content bg-home">
			<div class="container">
                <div class="header-clear"></div>
                <div class="itemList-header">
                    <h1>Mi perfil</h1>
                </div>
                <div id="MyProfile">
                    <div id="itemList">
                        <div class="item-Form">
                            <div class="panel-body">
                                <div class="form-group">      
                                        <label for="">Nombre</label>
                                        <p>{{datosEmpleado.apellidos}}, {{datosEmpleado.nombre}}</p>
                                </div>
                                <div class="form-group">
                                        <label for="">Código QR</label>
                                        <div>
                                            <span>&nbsp;</span>
                                        </div>
                                        <div id="divQR">
                                            <qr-code :text="datosEmpleado.identificador" :size="sizeQR"></qr-code>
                                        </div>
                                        <div>
                                            <span>&nbsp;</span>
                                        </div>
                                        <div id="horaActual" class="text-center">
                                            <span class="label label-danger">{{ horaActual }}</span>
                                        </div>
                                </div>
                                <div class="form-group">
                                        <label for="">Email</label>
                                        <p>{{ datosEmpleado.email }}</p>
                                </div>
                                <div class="form-group mt15">
                                        <a href="javascript:void(0);" @click="solicitarNuevaContrasenia" class="btn btn-primary resetpassword">Cambiar contraseña</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import Encabezado from "@/components/Encabezado.vue";
import Footer from "@/components/Footer.vue";
import moment from "moment";

export default {
	name: "MiPerfil",
	components: {
		Encabezado,
		Footer,
	},
	data() {return {
        sizeQR: 128,
        horaActual: null
    }},
    beforeMount(){
        setInterval(this.actualizarHora, 1000);
    },
	mounted() {
		document.body.classList.remove("bg-login");
		document.body.classList.remove("login-page");
    },
	watch:{
		
	},
	computed: {
		datosEmpleado: function(){
            return this.$store.state.perfil.empleado;
        }
	},
	methods:{
        actualizarHora: function(){
            this.horaActual = moment().format('L LTS');
        },
		solicitarNuevaContrasenia: function(){
            this.$router.push('/solicitud-nueva-contrasenia');
        }
	}
};
</script>

<style>
	@import "../assets/styles/home.css";
    #divQR img {
        margin: auto;
    }
</style>
